/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Observatory = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    viewBox="0 0 182 92"
    ref={ref}
    css={{
      color: "#F4F6F8",
      height: "92px",
      width: "182px",
    }}
    {...props}
  >
    <g fill="none" fillRule="evenodd" transform="translate(1 1)">
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M90 0c49.706 0 90 40.294 90 90H0C0 40.294 40.294 0 90 0z"
      />
      <path
        fill="currentColor"
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M97.95 53.016l3.808-3.844 5.618 5.67-3.686 3.72"
      />
      <path
        fill="currentColor"
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M87 56v-4.014a1.84 1.84 0 0 1 .692-1.418 2.199 2.199 0 0 1 1.612-.466 18.872 18.872 0 0 1 17.15 15.778 1.8 1.8 0 0 1-.508 1.482 2.142 2.142 0 0 1-1.54.638H100.5"
      />
      <path fill="#F18686" d="M99 68c0-6.628-5.372-12-12-12s-12 5.372-12 12" />
      <path
        fill="currentColor"
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M72.5 68h29a2 2 0 0 1 2 2v19h-33V70a2 2 0 0 1 2-2z"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M99 68c0-6.628-5.372-12-12-12s-12 5.372-12 12"
      />
      <path
        fill="#74B0F4"
        d="M105.414 52.86l-1.754-1.76a4.74 4.74 0 0 1 0-6.672l.066-.066a1.182 1.182 0 0 1 1.672-.012l.012.012 6.74 6.8a1.21 1.21 0 0 1 0 1.702 4.74 4.74 0 0 1-6.704.028l-.032-.032z"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M105.414 52.86l-1.754-1.76a4.74 4.74 0 0 1 0-6.672l.066-.066a1.182 1.182 0 0 1 1.672-.012l.012.012 6.74 6.8a1.21 1.21 0 0 1 0 1.702 4.74 4.74 0 0 1-6.704.028l-.032-.032z"
      />
      <path
        fill="#74B0F4"
        d="M83.5 75.5h7a1 1 0 0 1 1 1V89h-9V76.5a1 1 0 0 1 1-1z"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M83.5 75.5h7a1 1 0 0 1 1 1V89h-9V76.5a1 1 0 0 1 1-1zM67.5 89h39"
      />
      <path
        fill="#CAD0D8"
        d="M53 31c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm75-3c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm37 50c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137z"
      />
      <circle cx={32.5} cy={67.5} r={1.5} fill="#CAD0D8" />
      <circle cx={57.5} cy={55.5} r={1.5} fill="#CAD0D8" />
      <circle cx={32.5} cy={34.5} r={1.5} fill="#CAD0D8" />
      <circle cx={12.5} cy={81.5} r={1.5} fill="#CAD0D8" />
      <circle cx={83.5} cy={16.5} r={1.5} fill="#CAD0D8" />
      <circle cx={76.5} cy={40.5} r={1.5} fill="#CAD0D8" />
      <circle cx={123.5} cy={16.5} r={1.5} fill="#CAD0D8" />
      <circle cx={149.5} cy={47.5} r={1.5} fill="#CAD0D8" />
      <circle cx={160.5} cy={62.5} r={1.5} fill="#CAD0D8" />
      <circle cx={138.5} cy={65.5} r={1.5} fill="#CAD0D8" />
      <g transform="translate(100 24)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(67 8)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(120 71)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(47 75)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(21 55)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
    </g>
  </svg>
));
